import type { IPublicClientApplication, AccountInfo } from '@azure/msal-browser';

interface WaitForAccountOptions {
  timeoutMs?: number;
  pollIntervalMs?: number;
}

export async function waitForAccount(
  instance: IPublicClientApplication,
  options: WaitForAccountOptions = {}
): Promise<AccountInfo | null> {
  const timeoutMs = options.timeoutMs ?? 5000;
  const pollIntervalMs = options.pollIntervalMs ?? 100;
  const start = Date.now();

  const getAccount = (): AccountInfo | null => {
    return instance.getActiveAccount() || instance.getAllAccounts()[0] || null;
  };

  const initialAccount = getAccount();
  if (initialAccount) {
    return initialAccount;
  }

  return new Promise((resolve) => {
    const intervalId = window.setInterval(() => {
      const account = getAccount();
      if (account) {
        window.clearInterval(intervalId);
        resolve(account);
        return;
      }

      if (Date.now() - start >= timeoutMs) {
        window.clearInterval(intervalId);
        resolve(null);
      }
    }, pollIntervalMs);
  });
}
